import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CustomEase } from 'gsap/CustomEase'
import { SplitText } from 'gsap/SplitText'
import { debounce } from '../utils/dom'

gsap.registerPlugin(ScrollTrigger, CustomEase, SplitText)

export default class extends BaseModule {
  init() {
    const { effect } = this.el.dataset
    this[effect]()
  }

  // landing() {
  //   const sides = this.el.querySelectorAll('[data-landing-side]')
  //   const leftImages = sides[0].querySelectorAll('[data-module-image]')
  //   const rightImages = sides[1].querySelectorAll('[data-module-image]')
  //   const imagesCount = leftImages.length
  //   const stayDuration = 4
  //   const transitionDuration = 1.5

  //   const tl = gsap.timeline({ repeat: -1, ease: 'power1.inOut' })

  //   // reset zIndex
  //   leftImages.forEach((image, i) => {
  //     tl.set(image, { zIndex: imagesCount - i })
  //   })
  //   rightImages.forEach((image, i) => {
  //     tl.set(image, { zIndex: imagesCount - i })
  //   })

  //   leftImages.forEach((image, i) => {
  //     tl.to(image, { xPercent: '-100', duration: transitionDuration }, stayDuration * (i + 1))
  //   })

  //   rightImages.forEach((image, i) => {
  //     tl.to(image, { xPercent: '100', duration: transitionDuration }, stayDuration * (i + 1))
  //   })

  //   tl.set(leftImages[0], { zIndex: -1, xPercent: 0 }, stayDuration * (imagesCount - 1))
  //   tl.set(rightImages[0], { zIndex: -1, xPercent: 0 }, stayDuration * (imagesCount - 1))
  // }

  sliderImageReveal() {
    window.addEventListener('swiper:init', () => {
      const images = this.el.querySelectorAll('[data-module-image')
      const height = images[0].parentNode.offsetHeight

      const tl = gsap.timeline({ paused: true })
      tl.to(images, {
        height,
        duration: 1,
        delay: 0.5,
        ease: 'power2.out',
      })

      ScrollTrigger.create({
        trigger: this.el,
        start: 'top bottom',
        end: 'bottom top',
        animation: tl,
      })
    })
  }

  reveal() {
    let split
    let trigger
    let completed = false
    let delay = 0

    if (this.el.dataset.effectDelay) {
      delay = parseFloat(this.el.dataset.effectDelay)
    }

    split = new SplitText(this.el, { type: 'lines' })
    const tl = gsap.timeline({
      paused: true,
      onComplete: () => {
        completed = true
        if (trigger) trigger.kill()
      },
    })
    tl.set(this.el, { autoAlpha: 1 })
    tl.from(split.lines, {
      duration: 0.6,
      delay,
      opacity: 0,
      yPercent: 50,
      stagger: 0.2,
    })

    trigger = ScrollTrigger.create({
      trigger: this.el,
      start: 'top bottom',
      end: 'bottom top',
      animation: tl,
    })

    const debouncedResize = debounce(() => {
      split.revert()
      if (!completed) {
        split = new SplitText(this.el, { type: 'lines' })
        trigger.refresh()
      } else {
        gsap.set(this.el, { autoAlpha: 1 })
      }
    }, 250)

    window.addEventListener('resize', debouncedResize)
  }
}
